import React from 'react';
import SurveyHeader from '../components/SurveyHeader';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import { useAppSelector } from '../redux/ReduxProvider';

const useStyles = makeStyles((theme) => ({
  root: theme.defaultLayout.root,
  title: theme.defaultLayout.title,
  container: theme.defaultLayout.container,
  content: theme.defaultLayout.content,
}));

const ErrorPage = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  const { logoUrl: companyLogoUrl, brandColor: companyBackgroundColor } = useAppSelector((state) => state.company);

  // This is a simple aggregate of `error` states from key reducers.
  // TODO: upgrade this functionality to a dedicated "notifications" module.
  const errorMessage = useAppSelector((state) => {
    const kioskError = state.kiosk.error;
    const surveyError = state.survey.error;
    const companyError = state.company.error;

    return [kioskError, surveyError, companyError]
      .reduce((errors, el) => {
        return el !== '' ? [...errors, el] : errors;
      }, [])
      .join(', ');
  });

  return (
    <div className={styles.root}>
      <SurveyHeader backgroundColor={companyBackgroundColor} logoUrl={companyLogoUrl} />

      <article className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>{t('survey.error.title')}</h1>
          <Typography>{errorMessage}</Typography>
        </div>
      </article>
    </div>
  );
};

export default ErrorPage;
